<template>
  <v-theme-provider :dark="dark">
    <v-container class="pa-0">
      <v-row
        :justify="justify"
        no-gutters
      >

        <v-col
          v-if="cover"
          :class="`text-${align}`"
          cols="12"
          class="mb-4"
        >
          <img :src="`${cover}`" width="100%" />
        </v-col>

        <!-- <v-col
          v-if="title"
          :cols="callout ? 9 : 12"
        >

          <base-title
            :title="title"
            class="text-uppercase"
            space="1"
          />

          <base-divider v-if="text || $slots.default" :color="color" />

          <base-body
            v-if="text || $slots.default"
            :text="text"
            space="6"
          >
            <slot />
          </base-body>
        </v-col> -->
      </v-row>
    </v-container>
  </v-theme-provider>
</template>

<script>
  // Mixins
  import Heading from '@/mixins/heading'

  export default {
    name: 'BookCard',

    mixins: [Heading],

    props: {
      dark: Boolean,
      callout: String,
      color: {
        type: String,
        default: 'primary',
      },
      icon: String,
      text: String,
      title: String,
      cover: String,
    },
  }
</script>
